import { render, staticRenderFns } from "./TableAllocationProposalSent.vue?vue&type=template&id=62908b3e&scoped=true"
import script from "./TableAllocationProposalSent.vue?vue&type=script&lang=js"
export * from "./TableAllocationProposalSent.vue?vue&type=script&lang=js"
import style0 from "./TableAllocationProposalSent.vue?vue&type=style&index=0&id=62908b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62908b3e",
  null
  
)

export default component.exports